import { RefObject } from "react";
import { AppBar, Box, Toolbar } from "@mui/material";

import { useAppSelector } from "../../app/hooks";
import Logo from "./Logo";
import User from "./User";
import BarMenu from "./Menu";

export default function Bar(props: { withRef: RefObject<HTMLDivElement | null> }) {
  const loggedIn = useAppSelector((state) => state.auth.loggedIn);

  return (
    <AppBar ref={props.withRef} position="sticky">
      <Toolbar>
        <Box sx={{ display: "flex", flexGrow: 1 }}>
          {loggedIn && <BarMenu />}
          <Box sx={{ flexGrow: 1 }} />
          <Logo />
          <Box sx={{ flexGrow: 1 }} />
        </Box>
        {loggedIn && <User />}
      </Toolbar>
    </AppBar>
  );
}
